import { render, staticRenderFns } from "./CreateTasksModal.vue?vue&type=template&id=05858036&scoped=true&"
import script from "./CreateTasksModal.vue?vue&type=script&lang=js&"
export * from "./CreateTasksModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateTasksModal.vue?vue&type=style&index=0&id=05858036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05858036",
  null
  
)

export default component.exports